import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-central-farm-map',
  template: `
  <maphilight
    id="CentralMap"
    [config]="config">
    <img src="../images/CentralFarm.jpg"
      class="map"
      usemap="#CentralFarmArea"
      alt="Beltsville Agricultural Research Center Central Farm"
      height="587"
      width="760"
      border="0"/>
    <map name="CentralFarmArea">
      <area (click)="selectSite.emit('BARC 8')"
        alt="BARC 8"
        shape="rect"
        coords="103,512,145,525">
      <area (click)="selectSite.emit('BARC 9')"
        alt="BARC 9"
        shape="rect"
        coords="275,92,313,106">
      <area (click)="selectSite.emit('BARC 10')"
        alt="BARC 10"
        shape="rect"
        coords="339,510,384,524">
      <area (click)="selectSite.emit('BARC 11')"
        alt="BARC 11"
        shape="rect"
        coords="601,446,647,460">
      <area (click)="selectSite.emit('BARC 12')"
        alt="BARC 12"
        shape="rect"
        coords="608,207,652,220">
      <area (click)="selectSite.emit('BARC 22')"
        alt="BARC 22"
        shape="rect"
        coords="67,426,112,440">
      <area (click)="selectSite.emit('BARC 26')"
        alt="BARC 26"
        shape="rect"
        coords="261,172,306,184">
      <area (click)="selectSite.emit('BARC 27')"
        alt="BARC 27"
        shape="rect"
        coords="476,515,522,531">
      <area (click)="selectSite.emit('BARC 30')"
        alt="BARC 30"
        shape="rect"
        coords="520,130,565,144">
      <area (click)="selectSite.emit('EPIC 31')"
        alt="EPIC 31"
        shape="rect"
        coords="410,512,451,523">
      <area (click)="selectSite.emit('BARC 32')"
        alt="BARC 32"
        shape="rect"
        coords="637,295,680,311">
      <area (click)="selectSite.emit('BARC 41')"
        alt="BARC 41"
        shape="rect"
        coords="613,422,660,433">
      <area (click)="selectSite.emit('BHNRC')"
        alt="BHNRC"
        shape="rect"
        coords="201,189,238,202">
      <area (click)="selectSite.emit('Building 421')"
        alt="Building 421"
        shape="rect"
        coords="517,476,553,487">
      <area (click)="selectSite.emit('CSWRP')"
        alt="CSWRP"
        shape="rect"
        coords="635,269,675,286">
      <area (click)="selectSite.emit('ENTECH M12')"
        alt="ENTECH M12"
        shape="rect"
        coords="136,232,202,243">
      <area (click)="selectSite.emit('ENTECH M16')"
        alt="ENTECH M16"
        shape="rect"
        coords="74,255,139,269">
      <area (click)="selectSite.emit('ENTECH M22')"
        alt="ENTECH M22"
        shape="rect"
        coords="505,494,573,511">
      <area (click)="selectSite.emit('ENTECH M23')"
        alt="ENTECH M23"
        shape="rect"
        coords="52,389,118,403">
      <area (click)="selectSite.emit('ENTECH R1')"
        alt="ENTECH R1"
        shape="rect"
        coords="486,111,544,122">
      <area (click)="selectSite.emit('ENTECH R2')"
        alt="ENTECH R2"
        shape="rect"
        coords="552,345,609,358">
      <area (click)="selectSite.emit('ENTECH R3')"
        alt="ENTECH R3"
        shape="rect"
        coords="195,149,256,162">
      <area (click)="selectSite.emit('ENTECH R13')"
        alt="ENTECH R13"
        shape="rect"
        coords="546,462,610,473">
      <area (click)="selectSite.emit('ENTECH R23')"
        alt="ENTECH R23"
        shape="rect"
        coords="429,130,491,142">
      <area (click)="selectSite.emit('ENTECH 15')"
        alt="ENTECH 15"
        shape="rect"
        coords="550,365,606,376">
      <area (click)="selectSite.emit('EPIC 21')"
        alt="EPIC 21"
        shape="rect"
        coords="67,475,107,488">
      <area (click)="selectSite.emit('EPIC 23')"
        alt="EPIC 23"
        shape="rect"
        coords="67,456,108,468">
      <area (click)="selectSite.emit('BARC 31')"
        alt="BARC 31"
        shape="rect"
        coords="543,319,588,333">
      <area (click)="selectSite.emit('EPIC 34')"
        alt="EPIC 34"
        shape="rect"
        coords="406,102,444,113">
      <area (click)="selectSite.emit('EPIC 39')"
        alt="EPIC 39"
        shape="rect"
        coords="577,125,615,139">
      <area (click)="selectSite.emit('FDA 1')"
        alt="FDA 1"
        shape="rect"
        coords="339,119,370,131">
      <area (click)="selectSite.emit('FDA 2')"
        alt="FDA 2"
        shape="rect"
        coords="373,111,404,122">
    </map>
  </maphilight>
  `
})
export class CentralFarmMapComponent {
  @Input() config: any;
  @Output() selectSite: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/central-farm-map.ts